<ion-header id="app-header">
  <ion-toolbar color="primary">
    <ng-content/>
    <ion-title color="light20">{{ title }}</ion-title>
    <app-online-status slot="end"/>
  </ion-toolbar>
</ion-header>
